var a=function(){};export{a as w};
